export default {
    categoryIcon: ({ categoryIconMap }) => (category) => {
        if (!category) return null;

        return categoryIconMap[category.toLowerCase()];
    },
};
